import React from 'react';
import { Route, Switch } from 'react-router-dom';

import StockMovementForm from '../../../Maintenance/StockMovement/index';



export default () => (
  <Switch>
    <Route path="/Maintenance/stockMovement" component={StockMovementForm} />
    
    
  </Switch>
);
